/**
 * Shared pagination helpers for list/report views that use <paginate>.
 */

/**
 * Reset paginator to the first page (call before filter-driven loads).
 * @param {{ page?: number } | null | undefined} paginator
 */
export function resetPaginatorPage(paginator) {
  if (paginator && typeof paginator.page === 'number') {
    paginator.page = 1;
  }
}

/**
 * Reports keep their current page while request parameters stay unchanged.
 * The first request has no previous query to compare against.
 * @param {Record<string, unknown> | null} previousQuery
 * @param {Record<string, unknown>} currentQuery
 */
export function shouldResetPageForQuery(previousQuery, currentQuery) {
  if (previousQuery === null) {
    return false;
  }

  const previousRowQuery = { ...previousQuery };
  const currentRowQuery = { ...currentQuery };
  delete previousRowQuery.metrics;
  delete currentRowQuery.metrics;

  return JSON.stringify(previousRowQuery) !== JSON.stringify(currentRowQuery);
}

/**
 * Mixin: search() resets to page 1, then calls loadData.
 * Use for filter changes / debounced keyword that bypass <filters> submit.
 * Filter form submit is handled in Filters.vue; out-of-range pages in Paginate.vue.
 */
export const paginateSearch = {
  methods: {
    search(...args) {
      resetPaginatorPage(this.paginate);
      if (typeof this.loadData === 'function') {
        return this.loadData(...args);
      }
    },
  },
};

export default paginateSearch;
